import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TextComponent from "@/builder/components/text/TextComponent.vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { ref, watch } from "vue";
import { handleMergeTags } from "../../BuilderUtilities";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextRenderContainer',
  props: ["component"],
  setup(__props) {

const props = __props;

const renderStore = useRenderStore();

const text = ref(handleMergeTags(props.component.customData.value) ?? "");

//watch for net amount changes in renderStore
watch(() => renderStore.netAmount, (newVal, oldVal) => {
    text.value = handleMergeTags(props.component.customData.value) ?? "";
}), { immediate: true, deep: true };

//watch cover gift changes in renderStore
watch(() => renderStore.gift, (newVal, oldVal) => {
    text.value = handleMergeTags(props.component.customData.value) ?? "";
}, { immediate: true, deep: true })

//watch for donor changes in renderStore
watch(() => renderStore.donor, (newVal, oldVal) => {
    text.value = handleMergeTags(props.component.customData.value) ?? "";
}, { immediate: true, deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextComponent, {
    text: text.value,
    component: __props.component
  }, null, 8, ["text", "component"]))
}
}

})